import { interval as observableInterval, Observable, Subscription } from 'rxjs';
import { Injectable, isDevMode } from '@angular/core';

import { StoreService } from '../_service/store.service';

import { Histogram } from '../_helper/histogram';
import { Speed } from '../_helper/speed';
import { share } from 'rxjs/operators';

@Injectable()
export class UploadService {

    progress: number;
    progress2$: Observable<any>;
    progressObserver: any;
    histogram$: Observable<any>;
    histogramObserver: any;
    all: number;
    total: number;
    startTime: Date;
    currentTime: Date;
    duration: number;
    uploadedData = 0;

    progressArray: any[];
    threadSum = 0;
    threadId = 0;

    // dataUpload: string;
    dataUpload: Blob;

    threads = 3;
    threadCount = 0;
    threadCounter: number = this.threads - 1; // all - 1

    testDuration = 10000;

    // testDuration: number = 1000;
    isDurationPassed: Boolean = false;
    requestArray: any[] = [];

    notify$: Observable<any>;
    notifyObserver: any;

    subSpeed: Subscription;
    subHistogram: Subscription;

    uploadList: number[] = [];
    timeList: number[] = [];

    private histo: Histogram = new Histogram();
    private speed: Speed = new Speed();

    constructor(private storeService: StoreService) {
        if (isDevMode()) {
            this.testDuration = 2000;
        }

        this.progress2$ = new Observable((observer) => {
            this.progressObserver = observer;
        }).pipe(share());
        this.notify$ = new Observable((observer) => {
            this.notifyObserver = observer;
        }).pipe(share());
        this.histogram$ = new Observable((observer) => {
            this.histogramObserver = observer;
        });

        const r = new ArrayBuffer(1048576);
        const req = [];
        for (let i = 0; i < 20; i++) {
            req.push(r);
        }
        this.dataUpload = new Blob(req);

    }

    getUploadLength() {
        return (this.threads * this.dataUpload.size);
    }

    upload(): Observable<any> {
        this.notifyObserver.next('start');

        this.requestArray = [];
        this.isDurationPassed = false;

        this.threadCount = 0;
        this.all = 0;
        this.total = 0;
        this.progressArray = [];
        this.startTime = new Date();
        this.uploadList = [];
        this.timeList = [];

        this.speed = new Speed();
        this.histo = new Histogram();

        this.subSpeed = observableInterval(100).subscribe((val) => {
            this.calculateSpeed();
        });

        this.subHistogram = observableInterval(250).subscribe((val) => {
            this.calculateHistogram();
        });

        return new Observable((observer) => {
            setTimeout(() => {
                this.cancelAll(this, observer);
            },this.testDuration);

            for (let i = 0; i < this.threads; ++i) {
                this.threadCounter = i;
                this.uploadThreat(observer, this.threadCounter);
            }
        });
    }

    uploadThreat(observer: any, i: number) {
        const url: string = this.storeService.testServer.uploadUrl;

        const xhr: XMLHttpRequest = new XMLHttpRequest();
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 2) { // HEADERS_RECEIVED
                const contentLength = xhr.getResponseHeader('Content-Length');
                if (contentLength != null) {
                    this.total += parseInt(contentLength);
                }
            } else if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    // Successfully completed this request
                } else {
                    observer.error(xhr.response);
                }
            }
        };

        xhr.upload.onload = () => {
            // console.log("xhr.upload.onload");
            this.threadCounter++;
            if (!this.isDurationPassed) {
                this.uploadThreat(observer, this.threadCounter);
            }
        };

        xhr.upload.onabort = () => {
            // console.log("xhr.upload.onabort");
        };

        xhr.upload.onprogress = this.createProgressHandler(new Date(), i);

        xhr.open('POST', url + '?' + Math.random(), true); // random string to prevent caching
        xhr.send(this.dataUpload);
        this.requestArray.push(xhr);
    }

    calculateSpeed() {
        this.sumUpData();
        this.uploadList.push(this.uploadedData);
        this.timeList.push((new Date()).getTime());

        const speed = this.speed.calculateCurrentSpeedMbps(this.uploadList, this.timeList, 100);
        const progress: number = ((new Date()).getTime() - this.startTime.getTime()) / this.testDuration;

        const object = {
            speed: speed,
            progress: progress,
        };

        this.progressObserver.next(object);
    }

    sumUpData() {
        let sum = 0;
        for (let i = this.progressArray.length - 1; i >= 0; i--) {
            const obj = this.progressArray[i];
            if (obj != null && obj.bytes != undefined) {
                sum += obj.bytes;
            }
        }
        this.uploadedData = sum;
        this.storeService.test.uploadedData = sum;
    }

    onload(i: number) {
        return function (event) {
            this.progressArray[i] = {bytes: 0};
        };
    }

    createProgressHandler(start: any, i: number) {
        const self = this;

        return function (event) {
            if (self.progressArray[i] == null || self.progressArray[i] == undefined) {
                self.progressArray[i] = {bytes: 0};
            }

            const bytes = event.loaded;
            self.progressArray[i].bytes = bytes;
        };
    }

    cancelAll(self, observer) {
        self.isDurationPassed = true;
        self.notifyObserver.next('end');
        observer.complete();

        setTimeout(function () {
            for (let i = 0; i < self.requestArray.length; ++i) {
                const xhr: XMLHttpRequest = self.requestArray[i];
                xhr.abort();
            }
            self.subSpeed.unsubscribe();
            self.subHistogram.unsubscribe();
        }, 100);
    }

    calculateHistogram() {
        const progressTime: number = ((new Date()).getTime() - this.startTime.getTime()) / this.testDuration;
        const gram = this.histo.createHistogramValues(this.uploadList, this.timeList, 0, progressTime, this.testDuration, 60);
        this.storeService.test.uploadHistogram = gram;
        this.histogramObserver.next(gram);
    }

}
